import LoadingButton from '@mui/lab/LoadingButton';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { type FC } from 'react';

import ShiftScopeDialog from './ShiftScopeDialog.js';

const DELETE_SCOPE_OPTIONS = [
  { value: 'this', label: 'This occurrence' },
  { value: 'following', label: 'This & following' },
];

interface ShiftDeleteConfirmDialogProps {
  open: boolean;
  isRecurring: boolean;
  loading?: boolean;
  onConfirm: (scope: 'this' | 'following') => void;
  onCancel: () => void;
}

const ShiftDeleteConfirmDialog: FC<ShiftDeleteConfirmDialogProps> = ({
  open,
  isRecurring,
  loading,
  onConfirm,
  onCancel,
}) => {
  if (isRecurring) {
    return (
      <ShiftScopeDialog
        open={open}
        title="Delete shift"
        options={DELETE_SCOPE_OPTIONS}
        defaultValue="this"
        actionLabel="Delete"
        actionColor="error"
        loading={loading}
        onConfirm={(scope) => onConfirm(scope as 'this' | 'following')}
        onCancel={onCancel}
      />
    );
  }

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Delete shift?</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          This will permanently remove this shift. This can&apos;t be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <LoadingButton color="error" variant="contained" loading={loading} onClick={() => onConfirm('this')}>
          Delete shift
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ShiftDeleteConfirmDialog;
